import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '../Button';
import styles from './Controls.module.scss';

const Controls = ({ className, testId, hideCancel, showSubmit, submitColor, cancelText, size, isSubmitDisabled, isLoading, isSubmitSuccess, submitText, onCancelClick, onSubmitClick }) => {
  return <div data-testid={testId} className={cn(styles.container, className, {
    [styles.oneButton]: hideCancel
  })}>
    {!hideCancel && <Button
      testId={testId && `${testId}-cancel`}
      title={cancelText || 'Cancel'}
      buttonType='secondary'
      color='gray'
      fullWidth
      size={size}
      onClick={onCancelClick} />}
    {showSubmit && <Button
      testId={testId && `${testId}-submit`}
      title={submitText || 'Save'}
      color={submitColor || isSubmitSuccess ? 'green' : 'gray'}
      fullWidth
      size={size}
      showLoader={isLoading}
      inactive={!isSubmitSuccess && (isSubmitDisabled || isLoading)}
      onClick={!isSubmitSuccess && onSubmitClick} />}
  </div>;
};

Controls.propTypes = {
  className: PropTypes.string,
  testId: PropTypes.string,
  hideCancel: PropTypes.bool,
  showSubmit: PropTypes.bool,
  submitColor: PropTypes.any,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  onCancelClick: PropTypes.func,
  onSubmitClick: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

Controls.defaultProps = {
  hideCancel: false,
  showSubmit: true,
  isSubmitDisabled: false,
  isLoading: false
};

export default Controls;
